<section>
    <img width="100%" src="/assets/images/micrositio/homepage/HOME_042.jpg">
    <br>
    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
</section>
<div class="container">
    <div class="row p-5">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20 text-grey">
                        RECORRIDOS
                    </p>
                    <p class="fontMS700 colorPrincipal font-40" style="line-height: 2.5rem;">
                        MIRADAS DESDE EL ARTE
                        <br>
                    </p>
                </div>
                <div class="col-sm-5">
                    <div id="sharePic">
                        <a (click)="test.toggle()" mdbWavesEffect>
                            <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
                        </a>
                        <div mdbCollapse #test="bs-collapse">
                            <div class="divShared">
                                &nbsp;
                                &nbsp;
                                <a target="_blank"
                                    href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica2">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica2">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica2">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20">
                        <br>
                        <span class="fontMS500 font-22">
                            LA BIBLIOTECA NACIONAL DEL PERÚ CONSERVA UN ACERVO SIGNIFICATIVO DE GRABADOS, DIBUJOS,
                            PINTURAS, MÚSICA Y FOTOGRAFÍA DE DIFERENTES PERIODOS Y ARTISTAS. CADA UNA DE ESTAS PIEZAS
                            CONFIGURAN UNA HUELLA SENSIBLE Y SE TORNAN DOCUMENTO DE SU TIEMPO.
                            <br><br>
                        </span>
                        El arte es un rasgo fundamental de la humanidad, es una búsqueda de conocimiento, propicia la
                        reflexión e interpretación de nuestro contexto y su difusión en la comunidad promueve la
                        diversidad y la identidad cultural.
                        En el recorrido “Miradas desde el arte” se indaga, analiza e interpreta las colecciones de
                        Courret (fotografía de fines del siglo XIX e inicios del siglo XX), Holzmann (partituras de
                        fines del siglo XIX hasta mediados del siglo XX), José María Eguren (dibujos, acuarelas,
                        óleos y fotografías), entre otras.
                        <br><br>
                    </p>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4">
                    <p class="fontMS500 font-22">
                        <br> OTROS RECORRIDOS <br>
                        <span class="font-20 text-grey">
                            <u>
                                <a style="color: inherit;" (click)="creadores()">Creadores</a><br>

                                <a style="color: inherit;" (click)="comunidadesImg()">Comunidades imaginadas</a><br>

                                <a style="color: inherit;" (click)="transiciones()">Transiciones y transformaciones <br>
                                    sociales </a><br>
                            </u>
                        </span>
                    </p>
                </div>
            </div>
            <p class="fontMS500 font-30">
                TEMAS
            </p>
            <div class="row">
                <div class="col-sm-8">
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Reportaje2()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024f.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Reportaje2()">
                                <p class="fontMS700 font-24">
                                    REPORTAJE Y PROPAGANDA: NOTICIAROS CINEMATOGRÁFICOS PERUANOS DE LOS 40 (PARTE II)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Reportaje()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024f.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Reportaje()">
                                <p class="fontMS700 font-24">
                                    REPORTAJE Y PROPAGANDA: NOTICIAROS CINEMATOGRÁFICOS PERUANOS DE LOS 40
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Construccion()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024g.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Construccion()">
                                <p class="fontMS700 font-24">
                                    LA CONSTRUCCIÓN DE LA TRADICIÓN: ACUARELAS COSTUMBRISTAS DEL ÁLBUM PRAETORIA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Compositores()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024a.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Compositores()">
                                <p class="fontMS700 font-24">
                                    MÚSICA ANDINA, MESTIZA Y CRIOLLA EN LOS COMPOSITORES ACADÉMICOS (1900-1950)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="RetratoFoto()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024b.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="RetratoFoto()">
                                <p class="fontMS700 font-24">
                                    EL RETRATO FOTOGRÁFICO EN LIMA (1860-1930)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="RetratoInmigracion()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024c.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="RetratoInmigracion()">
                                <p class="fontMS700 font-24">
                                    LOS RETRATOS DE LA INMIGRACIÓN DEL SIGLO XIX
                                </p>
                            </a>
                        </div>
                    </div>
                    <!-- <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="AlbumRepublica()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024d.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="AlbumRepublica()">
                                <p class="fontMS700 font-24">
                                    ÁLBUM REPÚBLICA PERUANA 1900<br>
                                    ALBORES Y ANHELOS 
                                    DE MODERNIZACIÓN
                                </p>
                            </a>
                        </div>
                    </div> -->
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="MalagaGrenet()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_024e.jpg">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="MalagaGrenet()">
                                <p class="fontMS700 font-24">
                                    RETRATOS DE PRENSA<br> LA PLUMA DE MÁLAGA GRENET
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Album()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_047a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Album()">
                                <p class="fontMS700 font-24">
                                    ÁLBUM DE AUTÓGRAFOS<br> 
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Exlibris()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_048a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Exlibris()">
                                <p class="fontMS700 font-24">
                                    DETRÁS DE LOS EXLIBRIS EN EL PERÚ<br>
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Moda()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_049a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Moda()">
                                <p class="fontMS700 font-24">
                                    MODA DE SIGLO XIX<br> 
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-4">
                            <a (click)="Renacer()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_054a.png">
                            </a>
                        </div>
                        <div class="col-sm-8">
                            <a (click)="Renacer()">
                                <p class="fontMS700 font-24">
                                    RENACER DE LAS CENIZAS INCENDIO Y RECUPERACIÓN DE LA BNP
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
        </div>
    </div>
</div>